import { render, staticRenderFns } from "./StatisticCard.vue?vue&type=template&id=18a26798&scoped=true&"
import script from "./StatisticCard.vue?vue&type=script&lang=js&"
export * from "./StatisticCard.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCard.vue?vue&type=style&index=0&id=18a26798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a26798",
  null
  
)

export default component.exports